module.exports = __webpack_public_path__ + "static/img/lylogo.cc5bcf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lylogo.png
// module id = /69E
// module chunks = 0